import { AppSidebar } from "@/components/app-sidebar"
import { AuthGuard } from "@/components/auth-guard"
import { MobileTabBar } from "@/components/mobile-tab-bar"
import { SiteHeader } from "@/components/site-header"
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar"
import { cn } from "cn"

export function DashboardShell({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return (
    <AuthGuard>
      <div className="h-dvh">
        <SidebarProvider className="h-full min-h-0">
          <AppSidebar />
          <SidebarInset className="min-h-0 overflow-hidden">
            <SiteHeader />
            {/* Tagged so the router restores this pane's scroll on back/forward,
                not just the window's. */}
            <div
              data-scroll-restoration-id="dashboard-main"
              className={cn(
                "flex flex-1 flex-col gap-3 overflow-auto overscroll-contain p-3 sm:gap-4 sm:p-4 [&>*]:min-w-0 [&>*]:shrink-0",
                className
              )}
            >
              {children}
            </div>
            <MobileTabBar />
          </SidebarInset>
        </SidebarProvider>
      </div>
    </AuthGuard>
  )
}
